import type { CSSProperties } from 'react';
import { colorRefToCss } from '@/lib/colorRefs';

// ============================================================================
// StyleBadge — бейдж/надпись по СТИЛЮ оформления (платформенный механизм):
// цвета — СЛОТЫ темы (var(--color-<slot>), один цвет в разных темах разный),
// ссылки на ЦВЕТА справочника (@имя → hex, SSoT — сервер) или hex; шрифт
// (жирный/курсив/зачёркнутый/подчёркнутый/размер); иконка (UTF/эмодзи).
// ============================================================================

export interface StyleAttrs {
  textColor?: string;        // слот темы ('success'), ссылка на цвет ('@Зелёный') или hex
  backgroundColor?: string;  // слот темы, ссылка на цвет или hex
  bold?: boolean;
  italic?: boolean;
  strikethrough?: boolean;
  underline?: boolean;
  fontSize?: number;
  icon?: string;
}

// CSS-значение по ссылке: '@имя' → hex из справочника, '#hex' → hex,
// иначе слот темы → var(--color-<слот>)
export function colorValue(c: string | undefined): string {
  if (!c) return '';
  return colorRefToCss(c);
}

export function styleCss(attrs: StyleAttrs | undefined): CSSProperties {
  const a = attrs || {};
  const style: CSSProperties = {};
  if (a.textColor) style.color = colorValue(a.textColor);
  if (a.backgroundColor) style.backgroundColor = colorValue(a.backgroundColor);
  if (a.bold) style.fontWeight = 700;
  if (a.italic) style.fontStyle = 'italic';
  if (a.strikethrough) style.textDecoration = 'line-through';
  if (a.underline) style.textDecoration = 'underline';
  if (a.fontSize) style.fontSize = a.fontSize;
  return style;
}

export function StyleBadge({ text, attrs, className }: { text: string; attrs?: StyleAttrs; className?: string }) {
  return (
    <span className={`inline-flex items-center gap-1 ${className || ''}`} style={styleCss(attrs)}>
      {attrs?.icon && <span className="text-[1em] leading-none">{attrs.icon}</span>}
      <span>{text}</span>
    </span>
  );
}
